import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bags-header',
  templateUrl: './bags-header.component.html',
  styleUrls: ['./bags-header.component.scss'],
})
export class BagsHeaderComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
